import { useAuth } from '@/shared/hooks/use-auth'
import { useUser } from '@/shared/hooks/use-user'
import { useFeatureEnabled } from '@/shared/hooks/use-feature-enabled'
import { FEATURE_FLAGS } from '@/shared/constants/feature-flags'
import { SUPPORT_PHONE } from '@/shared/constants/env'

export function useAppHeader() {
  const { isAuthenticated, logout, loading } = useAuth()
  const { user } = useUser()
  const showProfileMenu = !!useFeatureEnabled(FEATURE_FLAGS.WEB_APP_PROFILE)

  return {
    isAuthenticated,
    logout,
    loading,
    supportPhone: SUPPORT_PHONE,
    showProfileMenu,
    userName: user?.fullName ?? user?.name ?? '',
  }
}
